export const LOAD_MAP_WIDGET_DATA_REQUEST = "[DASHBOARD] LOAD_MAP_WIDGET_DATA_REQUEST";
